function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useCallback, useState, useEffect } from 'react';
import AutoCompleteV2 from '../../autocomplete-v2/AutoCompleteV2';
import { useFormContext } from '../FormContext';
export function AutoCompleteV2Adapter(_ref) {
  let {
    name,
    value,
    disabled,
    printSuggestion,
    onSuggestionSelected,
    ...rest
  } = _ref;
  const {
    setFieldValue
  } = useFormContext();
  const computeInputValue = useCallback(currentValue => currentValue ? printSuggestion(currentValue) : '', [printSuggestion]);
  const [inputValue, setInputValue] = useState(computeInputValue(value));
  useEffect(() => {
    setInputValue(computeInputValue(value));
  }, [value, computeInputValue]);
  const onInputChange = useCallback((newValue, action) => {
    switch (action) {
      case 'input-change':
        setInputValue(newValue);
        // It sets the field value to the new input (newValue), or clears it when the input (newValue) is empty
        setFieldValue(name, newValue ? value : null);
        break;
      case 'input-blur':
        // It keeps the previous input value or set it to an empty string when a user blurs the autocomplete
        setInputValue(computeInputValue(value));
        break;
      default:
    }
  }, [name, value, computeInputValue, setFieldValue]);
  const onInternalSuggestionSelected = useCallback(newValue => {
    setInputValue(computeInputValue(newValue));
    if (onSuggestionSelected) {
      onSuggestionSelected(newValue);
    }
  }, [computeInputValue, onSuggestionSelected]);
  return /*#__PURE__*/React.createElement(AutoCompleteV2, _extends({}, rest, {
    name: name,
    value: value,
    inputValue: !disabled ? inputValue : undefined,
    disabled: disabled,
    printSuggestion: printSuggestion,
    onInputChange: onInputChange,
    onSuggestionSelected: onInternalSuggestionSelected
  }));
}
export default AutoCompleteV2Adapter;
//# sourceMappingURL=AutoCompleteV2Adapter.js.map